<template>
  <div class="imageBackground">
    <!-- <img class="spin" src="../../assets/icons/chainring.png" height="32px" /> -->
    <!-- <div class="marquee" style="background: red;" >
      <h5>H5 asdba,sjdkasdhlkashdaklshdakshdaklshdaklshdlakjsd eewqeqwe qw eqwe qwe qweqwe qwe q weq goodbye</h5>
    </div>
    <component :is="marquee">ewkjdnkwndkwnedkwendlkwnedkljwend</component>
    <marquee>H5 asdba,sjdkasdhlkashdaklshdakshdaklshdaklshdlakjsd eewqeqwe qw eqwe qwe qweqwe qwe q weq goodbye</marquee> -->
    <!-- <div class="marquee" >
      <h3>H3 asdba,sjdkasdhlkashdaklshdakshdaklshdaklshdlakjsd eewqeqwe qw eqwe qwe qweqwe qwe q weq</h3>
     </div> -->
    <!-- <img :src="ic.getImageUrl('Ride')"  class="filter-green" >
    <img src="../assets/icons/sport/run.png" /> -->
    <!-- <img src="../assets/IMAG2697.jpg" style="opacity: 0.4" /> -->
    <!-- <sign-in/> -->
  </div>
</template>

<script>
import SignIn from '@/ux/components/SignIn';
import imageConv from '@/library/ImageConverter';

export default {
  components: { SignIn },
  data: () => ({
    ic: imageConv,
  }),
  methods:
    {
    },
};
</script>
<style lang="scss">
.imageBackground {
  background: url('../../assets/IMAG2697.jpg');
  background-repeat: no-repeat;
  background-size: auto;
  height: 100%;
  width: 100%;
  opacity: 0.4;
  background-position: center; 
}

</style>
